module.exports = __webpack_public_path__ + "static/OTPFrontend-0f009bfc678503c1ec495ed8c2916caa.png";